import { fetchHTML } from '@utils';

class RecommendedProducts extends HTMLElement {
  connectedCallback() {
    this.#fetchRecommendations();
  }

  async #fetchRecommendations() {
    try {
      const html = await fetchHTML(this.dataset.url);
      this.innerHTML = html.querySelector('recommended-products').innerHTML;
      this.#removeLoaders();
    } catch (error) {
      console.error(error);
      this.style.display = 'none';
    }
  }

  #removeLoaders() {
    setTimeout(() => {
      this.querySelectorAll('[data-loader]').forEach((loader) => {
        loader.ariaHidden = true;
      });
    }, 50);
  }
}

customElements.define('recommended-products', RecommendedProducts);
